import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PaymentMethod } from '../../../models/paymentMethod/paymentMethod';
import { AuthorizeFormComponent } from '../../../pages/terminal/authorize-form/authorize-form.component';
import { TokenizeDialogComponent } from '../../tokenize/tokenize-dialog/tokenize-dialog.component';
import { PaymentMethodService } from '../../../models/paymentMethod/paymentMethodService';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  standalone: false,
})
export class PaymentMethodsComponent {
  @Input() customerId: string = '';
  @Input() merchantId: string | undefined = '';
  @Input() paymentMethods: PaymentMethod[] = [];

  constructor(
    public dialog: MatDialog,
    private paymentMethodService: PaymentMethodService,
  ) {}

  ngOnInit() {}

  payWith(
    element: PaymentMethod,
    enterAnimationDuration: string,
    exitAnimationDuration: string,
  ) {
    const dialogRef = this.dialog.open(AuthorizeFormComponent, {
      data: {
        tokenizedCardId: element.tokenizedCardId,
        customerId: this.customerId,
        merchantId: this.merchantId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  createNew() {
    const dialogRef = this.dialog.open(TokenizeDialogComponent, {
      width: '500px',
      data: {
        merchantId: this.merchantId,
        //customerId: this.customerId
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.refreshPaymentMethods();
    });
  }

  refreshPaymentMethods() {
    this.paymentMethodService
      .getPaymentMethodsByCustomerId(this.customerId)
      .then((pms) => {
        this.paymentMethods = pms;
      });
  }
}
